import SmoothScroll from 'smooth-scroll'
import Navigation from './lib/navigation'
import Accordion from './lib/accordion'
import stickyContent from './lib/stickyContent'

/* -------------------------------------------------------------------
  utility
------------------------------------------------------------------- */
const smoothScroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
  popstate: true,
  updateURL: false
})

// header -------------------------------------------------

const setHeaderHeight = () => {
  const body = document.querySelector('.js-body')
  const header = document.querySelector('.js-header')
  const navInner = document.querySelector('.js-header-nav-inner')
  const headerRect = header.getBoundingClientRect()
  if(body.classList.contains('--on')) {
    navInner.style.height = ''
  } else {
    navInner.style.height = `calc(100vh - ${headerRect.height}px)`
  }
}
Navigation('js-header-nav-btn', 'js-body', setHeaderHeight)
Accordion()
